// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Y1te","requiredAsterisk":"Info_requiredAsterisk__QaJPn"};